import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface DashboardStatistic {
  today: {
    totalWorkingHours: number;
    presentCount: number;
    absentCount: number;
    leaveCount: number;
    halfDayCount: number;
    overtimeCount: number;
    totalEmployees: number;
    breakHours: number;
    date: string;
  };
  thisWeek: { totalWorkingHours: number; totalWeekHours: number };
  thisMonth: { totalWorkingHours: number; totalMonthlyHours: number };
  overtime: {
    hours: number;
    allowed: boolean;
    maxHours: number;
  };
  remaining: { hours: number };
}

export type DashboardStatisticsResponse = {
  success: boolean;
  message: string;
  data: DashboardStatistic;
};

const getDashboardStatistics =
  async (userId?: string): Promise<DashboardStatisticsResponse> => {
    const params = new URLSearchParams();
    if (userId) {
      params.append('userId', userId);
    }
    const response = await customAxios.get<DashboardStatisticsResponse>(
      `/attendance/employee/stats${params.toString() ? `?${params.toString()}` : ''}`
    );

    return response.data;
  };

export const useGetDashboardStatistics = (userId?: string) =>
  useQuery<DashboardStatisticsResponse, AxiosError>(
    ["dashboard-statistics", userId],
    () => getDashboardStatistics(userId),
    {
      onError: (error) =>
        showNotification({
          title: "Error Loading Dashboard Stats",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Something went wrong",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
